import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This file is autogenerated. Any changes will be overwritten in next build.

const Boleto = props => {
  const {
    size,
    color
  } = props;
  const sizeMap = {
    sm: 20,
    md: 24,
    lg: 28
  };
  let sizeValue = size;
  if (typeof size === 'number') {
    sizeValue = size;
  } else if (typeof size === 'string') {
    sizeValue = sizeMap[size];
  }
  return /*#__PURE__*/_jsxs("svg", {
    width: sizeValue,
    height: sizeValue,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M6.34841 4H5.28095V17.4737H4.42698V17.8947H4V19.5789H4.42698V20H19.5493V19.5789H20V17.8947H19.5493V17.4737H18.6479V4H17.7465L16.8095 5.05263H15.9555L15.1016 4H13.6071L12.5397 5.05263H11.6857L10.6182 4H9.1238L8.05634 5.05263H7.15493L6.34841 4Z",
      stroke: color
    }), /*#__PURE__*/_jsx("rect", {
      x: "7.15479",
      y: "8.88892",
      width: "9.91549",
      height: "1.33333",
      rx: "0.666667",
      fill: color
    }), /*#__PURE__*/_jsx("rect", {
      x: "7.15479",
      y: "12",
      width: "5.85915",
      height: "1.33333",
      rx: "0.666667",
      fill: color
    }), /*#__PURE__*/_jsx("rect", {
      x: "7.15479",
      y: "14.6667",
      width: "4.95775",
      height: "1.33333",
      rx: "0.666667",
      fill: color
    }), /*#__PURE__*/_jsx("rect", {
      x: "14.3662",
      y: "12",
      width: "2.70423",
      height: "1.33333",
      rx: "0.666667",
      fill: color
    }), /*#__PURE__*/_jsx("rect", {
      x: "14.3662",
      y: "14.6667",
      width: "2.70423",
      height: "1.33333",
      rx: "0.666667",
      fill: color
    })]
  });
};
export { Boleto };